import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

// Donut chart with a centered total label and a legend list with percentages,
// e.g. "Distribution by Method" on the dashboard.
export default function TspDonutChart({ data, centerLabel, centerValue, height = 220 }) {
  return (
    <div className="tsp-donut-wrap">
      <div className="tsp-donut-chart" style={{ height }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} dataKey="value" nameKey="name" innerRadius="68%" outerRadius="100%" paddingAngle={2} stroke="none">
              {data.map((entry) => (
                <Cell key={entry.name} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip formatter={(value, name) => [value, name]} />
          </PieChart>
        </ResponsiveContainer>
        <div className="tsp-donut-center">
          <div className="tsp-donut-center-value">{centerValue}</div>
          <div className="tsp-donut-center-label">{centerLabel}</div>
        </div>
      </div>
      <ul className="tsp-donut-legend">
        {data.map((entry) => (
          <li key={entry.name}>
            <span className="tsp-legend-dot" style={{ backgroundColor: entry.color }} />
            <span className="tsp-legend-name">{entry.name}</span>
            <span className="tsp-legend-value">{entry.percent}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
